var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 18.0312C4.79558 18.0312 0.96875 14.2036 0.96875 9.5C0.96875 4.79642 4.79558 0.96875 9.5 0.96875C14.2044 0.96875 18.0312 4.79642 18.0312 9.5C18.0312 14.2036 14.2044 18.0312 9.5 18.0312ZM9.5 2.28125C5.51987 2.28125 2.28125 5.51987 2.28125 9.5C2.28125 13.4801 5.51987 16.7187 9.5 16.7187C13.4801 16.7187 16.7187 13.4801 16.7187 9.5C16.7187 5.51987 13.4801 2.28125 9.5 2.28125Z",
    fill: "#D44215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0682 15.7246C14.9 15.7246 14.7326 15.6606 14.6039 15.5327L3.46735 4.39531C3.2114 4.13937 3.2114 3.72348 3.46735 3.46753C3.7233 3.21159 4.13918 3.21159 4.39513 3.46753L15.5325 14.6049C15.7884 14.8608 15.7884 15.2767 15.5325 15.5327C15.4045 15.6606 15.2363 15.7246 15.0682 15.7246H15.0682Z",
    fill: "#D44215"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.652087215172d80b790421486d31bd84.svg";
export { ForwardRef as ReactComponent };